module.exports = __webpack_public_path__ + "img/lightRain.c260b81f.svg";